import {useEffect, useState} from 'react'
import {useNavigate, Outlet} from 'react-router'
import {Pager} from 'brand/Pager'

import {lookIdsForAnswers} from 'pages/Looks/selectLooks'

const qPages = ['level', 'concerns', 'colours', 'occasion', 'vibes', 'weather', 'daily']
const afterQ = '/consult/load-looks'

export const Questionnaire = ({setAnswers}) => {
  const [pageNumber, setPageNumber] = useState(0)
  const [allAnswers, setAllAnswers] = useState({})
  const [lookIds, setLookIds] = useState(lookIdsForAnswers({}))

  const nav = useNavigate()
  useEffect(() => {
    const urlPathPage = window.location.pathname.split('/').slice(-1)[0]
    const pageIndex = qPages.indexOf(urlPathPage)
    if (pageIndex < 0) {
      nav(`./${qPages[0]}`)
    } else {
      setPageNumber(pageIndex)
    }
  }, [nav, setPageNumber])

  useEffect(() => {
    console.log('Answers so far:', allAnswers)
  }, [allAnswers])
  useEffect(() => {
    console.log('Available looks, given current answers:', lookIds.length)
  }, [lookIds])

  const nextPage = () => {
    const targetPage = pageNumber < qPages.length - 1
      ? `./${qPages[pageNumber + 1]}`
      : afterQ
    nav(targetPage)
  }

  const submitAnswers = answers => {
    const newAnswers = {...allAnswers, [qPages[pageNumber]]: answers}
    setAllAnswers(newAnswers)
    setAnswers(newAnswers)
    setTimeout(nextPage, 300)
    setLookIds(lookIdsForAnswers(newAnswers))
  }

  return (
    <>
      <Pager count={qPages.length} current={pageNumber} skipTo={afterQ} />
      {/* <div>Available looks, given current answers: {lookIds.length}</div> */}
      <Outlet context={{submitAnswers}}/>
    </>
  )
}
